import React from "react";
import Strings from "@my-dld/assets/strings";
import { TabuProcedure, TabuVoucher, TabuVoucherDetails } from "@10x/tabu-mobile-api/dist/requests/entity";
import CheckBoxField from "@my-dld/components/Form/CheckBoxField";
import { CurrencyUtil, LocaleUtil, StringUtil } from "@eres/core";
import cfg from "@10x/tabu-mobile-api/dist/config";
import { getParentFullPath } from "@my-dld/utils/PathUtils";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { CompleteTabuRequestData } from "./CompleteTabuRequest";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import BaseTabuRequestForm, { BaseTabuRequestProps } from "./BaseTabuRequestForm";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import PaymentFrame from "./PaymentFrame";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { openPayment } from "@my-dld/utils/Utils";
import { getConsumerId } from "../../configApp";

interface State {
	confirmPayment: boolean;
	error?: string;
	tabuProcedure: TabuProcedure;
	isPayment: boolean;
	paymentUrl?: string;
}

class TabuVoucherInfo extends BaseTabuRequestForm<BaseTabuRequestProps, State> {

	payment = React.createRef<PaymentFrame>();

	constructor( props: BaseTabuRequestProps ) {
		super( props );
		this.state = {
			isPayment: false,
			confirmPayment: false,
			tabuProcedure: props.location.state,
		};
	}

	render() {
		let total = 0;
		const v = this.state.tabuProcedure && this.state.tabuProcedure.Voucher ? this.state.tabuProcedure.Voucher : undefined;
		if ( v == null )
			return <Redirect to={ "/mydld" }/>;
		const voucher: TabuVoucher = this.state.tabuProcedure.Voucher!;
		return <>
			<PageContent hideQLinks={ true } title={ Strings.voucher_details }>
				<PageTitle title={ Strings.voucher_details } paths={ [ MyRequestsBCItem ] }/>
				<div className="flex-grid flex-column flex-nowrap">
					{ voucher.VoucherDetails.map( ( details: TabuVoucherDetails, index: number ) => {
						total += details.FeeValue;
						const name = LocaleUtil.getLocalValue( details.FeeEntity ).trim();
						const value = CurrencyUtil.toFormattedCurrency( details.FeeValue, 2 ) + " " + Strings.aed;
						return ( <div key={ "" + index }>
							<span>{ name }</span>
							<span>{ value }</span>
						</div> );
					} )
					}
					<div>
						<span>{ Strings.total }</span>
						<span>{ CurrencyUtil.toFormattedCurrency( total, 2 ) + " " + Strings.aed }</span>
					</div>
				</div>
				<CheckBoxField
					id={ "confirmPayment" }
					holder={ this }
					label={ Strings.confirm_payment }
					labelClassName={ "custom-control-label" }
					required={ true }
					error={ this.state.error }/>
				<button
					className="btn btn_1 btn_style1" type="submit"
					onClick={ this.onPay }>{ Strings.pay }</button>
			</PageContent>
			{ this.state.isPayment &&
				<PaymentFrame url={ this.state.paymentUrl! } onDismiss={ this.onPaymentDismiss } ref={ this.payment }/> }
		</>;
	}

	onPaymentDismiss = () => {
		this.setState( {
			isPayment: false,
		} );
	};

	private onPay = () => {
		this.setState( {
			error: this.state.confirmPayment ? undefined : Strings.please_confirm_payment,
		}, () => {
			if ( this.state.confirmPayment ) {
				this.openPaymentUrl();
			}
		} );
	};

	private openPaymentUrl = () => {
		let paymentURL = cfg.tabuAPI().appEndPoint() + "Payment/Payment.aspx?procedureId=" +
			this.state.tabuProcedure.ProcedureId + "&procedureYear=" + this.state.tabuProcedure.ProcedureYear +
			"&ProcedureNumber=" + this.state.tabuProcedure.ProcedureNumber;
		paymentURL = paymentURL + "&consumer-id=" + getConsumerId( paymentURL );
		let win: Window | null = null;
		// const t = this;
		let handled = false;
		window.name = "MyDLD";
		trackEventWithData( "TabuProcedure", "TryPay", {
			number: this.state.tabuProcedure.ProcedureNumber,
			year: this.state.tabuProcedure.ProcedureYear, id: this.state.tabuProcedure.ProcedureId
		} );
		const listener = ( event: any ) => {
			const data: any = event.data;
			if ( data ) {
				const type = data.type;
				if ( type === "eres_pay" ) {
					if ( this.payment.current ) this.payment.current.dismiss();
					this.setState( { isPayment: false } );
					window.removeEventListener( "message", listener );
					window.open( "", "MyDLD" )?.focus();
					if ( win ) {
						handled = true;
						if ( win.close )
							win.close();
						window.focus();
					}
					setTimeout( () => {
						hideLoading();
						if ( data.data ) {
							if ( !StringUtil.isEmptyStringOrNull( data.data.error ) ) {
								trackEventWithData( "TabuProcedure", "PaymentFail", {
									reason: data.data.error,
									number: this.state.tabuProcedure.ProcedureNumber,
									year: this.state.tabuProcedure.ProcedureYear,
									id: this.state.tabuProcedure.ProcedureId
								} );
								showErrorMessage( data.data.error );
							} else if ( !StringUtil.isEmptyStringOrNull( data.data.refNumber ) ) {
								trackEventWithData( "TabuProcedure", "PaymentSuccess", {
									number: this.state.tabuProcedure.ProcedureNumber,
									year: this.state.tabuProcedure.ProcedureYear,
									id: this.state.tabuProcedure.ProcedureId
								} );
								this.navigateToComplete( data.data.refNumber );
							}
						}
					}, 1 );
				}
			}
		};
		window.addEventListener( "message", listener, false );
		if ( window.AppInfo.usePaymentFrame ) {
			this.setState( {
				isPayment: true,
				paymentUrl: paymentURL
			} );
		} else {
			win = openPayment( paymentURL );
			if ( win ) {
				showLoading();
				const pollTimer = window.setInterval( function () {
					if ( !handled && win!.closed ) {
						window.clearInterval( pollTimer );
						window.removeEventListener( "message", listener );
						hideLoading();
					}
				}, 200 );
			} else {
				console.log( "no window" );
				showErrorMessage( "Enable Popup window to continue" );
			}
		}
	};

	private navigateToComplete = ( ref: string ) => {
		const req: CompleteTabuRequestData = {
			ProcedureId: this.state.tabuProcedure.ProcedureId,
			ProcedureNumber: "" + this.state.tabuProcedure.ProcedureNumber,
			ProcedureYear: "" + this.state.tabuProcedure.ProcedureYear,
			PaymentRef: ref,
			RequestStatusId: this.state.tabuProcedure.RequestStatusId,
		};
		const currentPath = getParentFullPath( this.props.location.pathname, "taburequest" );
		replaceNavigate( currentPath + "/complete", undefined, req );
	};
}

export default TabuVoucherInfo;
